<template>
  <div class="inner-wrapper">
    <div class="inner-wrapper-md">
    <div class="row">
      <div class="col-12">
        <h4 class="page-title">
          Reset your password 
        </h4>
        <p class="body">
          Enter your email address and we will send you a link to reset your
          password.
        </p>
        <AlertMessages />
        <form @submit.prevent="sendPassword">
          <div class="form-group">
            <div class="field-wrapper" v-flyout>
              <input
                type="email"
                class="text-field-3"
                id="email"
                placeholder=""
                v-model="Email"
                :class="{ 'is-invalid': $v.Email.$error }"
              />
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Email address</span>
              </div>
            </div>

            <div v-if="$v.Email.$error" class="feedback">
              <span v-if="!$v.Email.required">This field is required</span>
              <span v-if="!$v.Email.email && $v.Email.$dirty"
            >Incorrect email format</span
          >
            </div>
          </div>
          <div class="form-row cta-group flex-column-reverse flex-md-row">
            <router-link role="navigation" class="back-link" :to="{ name: 'signin' }">
              <span class="angle-left-green"></span>
              Back to sign in</router-link
            >
            <!-- <router-link
          class="cta-white-169"
          :to="{ name: 'password-reset', query: { id: '1' } }"
          @click.native="sendPassword()"
        >
          Send email<font-awesome-icon icon="angle-right" size="lg" />
        </router-link> -->
            <button class="cta-white-169">
              Send email<span class="angle-right-white" ></span>
            </button>
          </div>
        </form>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import { publicRouter } from "../router";
import AlertMessages from "../components/alert-messages";
import { RESETPASSWORD } from "../store/mutation-types";
export default {
  name: "PasswordForgot",

  //props: ["id"] ,
  //{
  //   id: {
  //     type: String,
  //    // default: 0,
  //   },
  // },
  components: { AlertMessages },
  // data() {
  //   return {
  //     email: "",
  //     // submitted: false,
  //     message: ""
  //   };
  // },
  validations: {
    Email: {
      required,
      email
    }
  },
  created() {
    
  },
  computed: {
    ...mapState("account", ["status"]),
    Email: {
      get() {
        return this.status.Email;
      },
      set(val) {
        this.$store.commit(`account/${RESETPASSWORD}`, { Email: val });
      }
    }
  },
  methods: {
    ...mapActions("account", ["forgotPassword"]),
    ...mapActions("alert", ["clear"]),
    async sendPassword() {
      this.clear();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let result = await this.forgotPassword({ username: this.Email });
      if (!this.hasError && result)
        publicRouter.push({ name: "password-reset", query: { id: "2" } });
    }
  }
};
</script>

<style lang="scss" scoped></style>
